import { PublicRoute } from "@/app/routes/public";
import { ProtectedRoute } from "@/app/routes/protected";
import { PATHS } from "@/lib/router";
import { FeatureProvider, Feature_NAMESPACES } from "@/lib/i18n";
import {
  AuthPage,
  ForgotPasswordPage,
  ResetPasswordPage,
  ChangePasswordPage,
  Verify2FACodePage,
} from "./pages";
import { SustainabilityPage } from "./components/SustainabilityPage";

export const authRoutes = [
  {
    path: PATHS.ROOT,
    element: (
      <PublicRoute>
        <FeatureProvider namespace={Feature_NAMESPACES.AUTH}>
          <SustainabilityPage />
        </FeatureProvider>
      </PublicRoute>
    ),
  },
  {
    path: PATHS.LOGIN,
    element: (
      <PublicRoute>
        <FeatureProvider namespace={Feature_NAMESPACES.AUTH}>
          <AuthPage />
        </FeatureProvider>
      </PublicRoute>
    ),
  },
  {
    path: PATHS.REGISTER,
    element: (
      <PublicRoute>
        <FeatureProvider namespace={Feature_NAMESPACES.AUTH}>
          <AuthPage />
        </FeatureProvider>
      </PublicRoute>
    ),
  },
  {
    path: PATHS.FORGOT_PASSWORD,
    element: (
      <PublicRoute>
        <FeatureProvider namespace={Feature_NAMESPACES.AUTH}>
          <ForgotPasswordPage />
        </FeatureProvider>
      </PublicRoute>
    ),
  },
  {
    path: PATHS.RESET_PASSWORD,
    element: (
      <PublicRoute>
        <FeatureProvider namespace={Feature_NAMESPACES.AUTH}>
          <ResetPasswordPage />
        </FeatureProvider>
      </PublicRoute>
    ),
  },
  {
    path: PATHS.CHANGE_PASSWORD,
    element: (
      <ProtectedRoute>
        <FeatureProvider namespace={Feature_NAMESPACES.AUTH}>
          <ChangePasswordPage />
        </FeatureProvider>
      </ProtectedRoute>
    ),
  },
  {
    path: PATHS.VERIFY_2FA_CODE,
    element: (
      <PublicRoute>
        <FeatureProvider namespace={Feature_NAMESPACES.AUTH}>
          <Verify2FACodePage />
        </FeatureProvider>
      </PublicRoute>
    ),
  },
];
